module.exports = __webpack_public_path__ + "img/card_view_student.2fbf4609.png";